
// @ts-nocheck


export const localeCodes =  [
  "es",
  "en"
]

export const localeLoaders = {
  es: [
    {
      key: "locale_es_46json_ebe62009",
      load: () => import("#nuxt-i18n/ebe62009" /* webpackChunkName: "locale_es_46json_ebe62009" */),
      cache: true
    }
  ],
  en: [
    {
      key: "locale_en_46json_7abb420b",
      load: () => import("#nuxt-i18n/7abb420b" /* webpackChunkName: "locale_en_46json_7abb420b" */),
      cache: true
    }
  ]
}

export const vueI18nConfigs = []

export const nuxtI18nOptions = {
  restructureDir: "i18n",
  experimental: {
    localeDetector: "",
    switchLocalePathLinkSSR: false,
    autoImportTranslationFunctions: false,
    typedPages: true,
    typedOptionsAndMessages: false,
    generatedLocaleFilePathFormat: "absolute",
    alternateLinkCanonicalQueries: false,
    hmr: true
  },
  bundle: {
    compositionOnly: true,
    runtimeOnly: false,
    fullInstall: true,
    dropMessageCompiler: false,
    optimizeTranslationDirective: false
  },
  compilation: {
    strictMessage: true,
    escapeHtml: false
  },
  customBlocks: {
    defaultSFCLang: "json",
    globalSFCScope: false
  },
  locales: [
    {
      code: "es",
      language: "es-UY",
      name: "Español",
      dir: "ltr",
      files: [
        {
          path: "/root/gastos-gub-uy/app/i18n/locales/es.json",
          cache: undefined
        }
      ]
    },
    {
      code: "en",
      language: "en",
      name: "English",
      dir: "ltr",
      files: [
        {
          path: "/root/gastos-gub-uy/app/i18n/locales/en.json",
          cache: undefined
        }
      ]
    }
  ],
  defaultLocale: "es",
  defaultDirection: "ltr",
  routesNameSeparator: "___",
  trailingSlash: false,
  defaultLocaleRouteNameSuffix: "default",
  strategy: "prefix_except_default",
  lazy: true,
  langDir: "locales",
  rootRedirect: undefined,
  detectBrowserLanguage: false,
  differentDomains: false,
  baseUrl: "https://conlatuya.checkleaked.cc",
  customRoutes: "page",
  pages: {},
  skipSettingLocaleOnNavigate: false,
  types: "composition",
  debug: false,
  parallelPlugin: false,
  multiDomainLocales: false,
  i18nModules: []
}

export const normalizedLocales = [
  {
    code: "es",
    language: "es-UY",
    name: "Español",
    dir: "ltr",
    files: [
      {
        path: "/root/gastos-gub-uy/app/i18n/locales/es.json",
        cache: undefined
      }
    ]
  },
  {
    code: "en",
    language: "en",
    name: "English",
    dir: "ltr",
    files: [
      {
        path: "/root/gastos-gub-uy/app/i18n/locales/en.json",
        cache: undefined
      }
    ]
  }
]

export const NUXT_I18N_MODULE_ID = "@nuxtjs/i18n"
export const parallelPlugin = false
export const isSSG = false
export const hasPages = true

export const DEFAULT_COOKIE_KEY = "i18n_redirected"
export const DEFAULT_DYNAMIC_PARAMS_KEY = "nuxtI18nInternal"
export const SWITCH_LOCALE_PATH_LINK_IDENTIFIER = "nuxt-i18n-slp"
/** client **/

/** client-end **/